export interface NumberFormatOptions {
  localeMatcher?: "lookup" | "best fit";
  style?: "decimal" | "percent" | "currency";
  currency?:
    | "AFN"
    | "EUR"
    | "ALL"
    | "DZD"
    | "USD"
    | "AOA"
    | "XCD"
    | "ARS"
    | "AMD"
    | "AWG"
    | "AUD"
    | "AZN"
    | "BSD"
    | "BHD"
    | "BDT"
    | "BBD"
    | "BYN"
    | "BZD"
    | "XOF"
    | "BMD"
    | "INR"
    | "BTN"
    | "BOB"
    | "BOV"
    | "BAM"
    | "BWP"
    | "NOK"
    | "BRL"
    | "BND"
    | "BGN"
    | "BIF"
    | "CVE"
    | "KHR"
    | "XAF"
    | "CAD"
    | "KYD"
    | "CLP"
    | "CLF"
    | "CNY"
    | "COP"
    | "COU"
    | "KMF"
    | "CDF"
    | "NZD"
    | "CRC"
    | "HRK"
    | "CUP"
    | "CUC"
    | "ANG"
    | "CZK"
    | "DKK"
    | "DJF"
    | "DOP"
    | "EGP"
    | "SVC"
    | "ERN"
    | "ETB"
    | "FKP"
    | "FJD"
    | "XPF"
    | "GMD"
    | "GEL"
    | "GHS"
    | "GIP"
    | "GTQ"
    | "GBP"
    | "GNF"
    | "GYD"
    | "HTG"
    | "HNL"
    | "HKD"
    | "HUF"
    | "ISK"
    | "IDR"
    | "XDR"
    | "IRR"
    | "IQD"
    | "ILS"
    | "JMD"
    | "JPY"
    | "JOD"
    | "KZT"
    | "KES"
    | "KPW"
    | "KRW"
    | "KWD"
    | "KGS"
    | "LAK"
    | "LBP"
    | "LSL"
    | "ZAR"
    | "LRD"
    | "LYD"
    | "CHF"
    | "MOP"
    | "MKD"
    | "MGA"
    | "MWK"
    | "MYR"
    | "MVR"
    | "MRU"
    | "MUR"
    | "XUA"
    | "MXN"
    | "MXV"
    | "MDL"
    | "MNT"
    | "MAD"
    | "MZN"
    | "MMK"
    | "NAD"
    | "NPR"
    | "NIO"
    | "NGN"
    | "OMR"
    | "PKR"
    | "PAB"
    | "PGK"
    | "PYG"
    | "PEN"
    | "PHP"
    | "PLN"
    | "QAR"
    | "RON"
    | "RUB"
    | "RWF"
    | "SHP"
    | "WST"
    | "STN"
    | "SAR"
    | "RSD"
    | "SCR"
    | "SLL"
    | "SGD"
    | "XSU"
    | "SBD"
    | "SOS"
    | "SSP"
    | "LKR"
    | "SDG"
    | "SRD"
    | "SZL"
    | "SEK"
    | "CHE"
    | "CHW"
    | "SYP"
    | "TWD"
    | "TJS"
    | "TZS"
    | "THB"
    | "TOP"
    | "TTD"
    | "TND"
    | "TRY"
    | "TMT"
    | "UGX"
    | "UAH"
    | "AED"
    | "USN"
    | "UYU"
    | "UYI"
    | "UYW"
    | "UZS"
    | "VUV"
    | "VES"
    | "VND"
    | "YER"
    | "ZMW"
    | "ZWL"
    | "XBA"
    | "XBB"
    | "XBC"
    | "XBD"
    | "XTS"
    | "XXX"
    | "XAU"
    | "XPD"
    | "XPT"
    | "XAG";
  currencyDisplay?: "symbol" | "code" | "name";
  useGrouping?: boolean;
  minimumIntegerDigits?:
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21;
  minimumFractionDigits?:
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20;
  maximumFractionDigits?:
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20;
  minimumSignificantDigits?:
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21;
  maximumSignificantDigits?:
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21;
}
